// extracted by mini-css-extract-plugin
export default {"menuList":"LockHandler_menuList__JHw3k","menuItem":"LockHandler_menuItem__vMuuZ font-sm-regular","menuItem__icon":"LockHandler_menuItem__icon__sMmXc"};